import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterPart1Component } from './register-part1/register-part1.component';
import { RegisterPart2Component } from './register-part2/register-part2.component';
import { EmailVerificationComponent } from '../../pages/email-verification/email-verification.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { DashboardlayoutComponent } from 'src/app/core/components/dashboardlayout/dashboardlayout.component';
import { UserRoleAuthGuard } from 'src/app/core/guards/user-role-auth.guard';




const routes: Routes = [

  
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: RegisterPart1Component
  },
  
  {
    path: 'signup-details',
    component: RegisterPart2Component
  },
  {
    path: 'email-verification',
    component: EmailVerificationComponent
  },
  { path: 'forget-password',
   component: ForgetPasswordComponent 
  },
  // {
  //   path: 'manage-profile',
  //   component: DashboardlayoutComponent,
  //   canActivate: [UserRoleAuthGuard],
  //   children: [
  //     { path: '', component: AccountManageComponent, canActivate: [UserRoleAuthGuard] },
  //   ]
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }